import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator from "../../../redux/action/actionCreator";

// core-components

import Toast from "../../../components/MessageToast";
import CreateForm from "../../components/forms/Form2";
import {
  CREATE_NEWSLETTER,
  UPDATE_NEWSLETTER,
} from "../../../redux/newsletter/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchNewsletterData } from "../../../redux/newsletter";

export default (props) => {
  const { newsletterId } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const operationStore = useSelector((store) =>
    newsletterId
      ? store.updateNewsletterGlobalStore
      : store.createNewsletterGlobalStore
  );

  const newsletterData = useSelector((state) => state.newsletterGlobalStore);

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  const [state, setState] = useState({
    openToast: false,
  });

  useEffect(() => {
    if (newsletterId && newsletterId !== newsletterData.data.id) {
      dispatch(fetchNewsletterData(newsletterId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { title, summary, fileUrl, imageUrl } = formData;
    if ((!title, !fileUrl, !imageUrl)) {
      return openToast({
        message: "Please fill all the required fields",
        type: "warning",
      });
    }
    const newsletterInfo = {
      title,
      summary,
      coverPhoto: imageUrl,
      pdfUrl: fileUrl || "",
      authorId: "",
    };

    await toast.promise(
      dispatch(
        actionCreator({
          method: newsletterId ? "PATCH" : "POST",
          path: newsletterId
            ? `/api/newsletters/${newsletterId}`
            : `/api/newsletters`,
          actionType: newsletterId ? UPDATE_NEWSLETTER : CREATE_NEWSLETTER,
          data: newsletterInfo,
        })
      ),
      {
        pending: `${!newsletterId ? "Creating" : "Updating"} Newsletter`,
      }
    );
    setState({ ...state, openToast: true });
  };

  if (operationStore.message && state.openToast) {
    Toast({
      message: operationStore.message,
      type: operationStore.message.includes("successful") ? "success" : "error",
      onClose: () =>
        operationStore.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }

  const crumps = [
    {
      title: "Newsletters",
      path: "/newsletters",
    },
  ];

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {newsletterId && newsletterData.loading ? (
        <Loading />
      ) : (
        <div>
          <CreateForm
            isCreate={newsletterId ? false : true}
            title="Create a Newsletter"
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseContentData={newsletterId ? newsletterData.data : {}}
            isLoading={operationStore.loading}
          />
        </div>
      )}
    </div>
  );
};
